import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { loginStatus, adminStatus } from 'store/slices/accountSlice';

// project imports
import { useEffect } from 'react';

// ==============================|| AUTH GUARD ||============================== //

/**
 * Authentication guard for routes
 * @param {PropTypes.node} children children element/node
 */
const AuthGuard = ({ children }) => {
    const isLoggedIn = useSelector(loginStatus);
    const isAdmin = useSelector(adminStatus);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate('login', { replace: true });
        } else if (isAdmin) {
            navigate('../admin', { replace: true });
        }
    }, [isLoggedIn, navigate, isAdmin]);

    return children;
};

AuthGuard.propTypes = {
    children: PropTypes.node
};

export default AuthGuard;
